import Route from '@ember/routing/route';

export default class AuthenticatedPlaylistsRoute extends Route {}
